import { createFileRoute } from '@tanstack/react-router'
import ContactAgreements from 'Contact/components/Contact/Sections/ContactAgreements'

export const Route = createFileRoute('/contact/$contactId/agreements')({
    component: ContactAgreements,
})
